/**
 * PasswordStrengthMeterControl
 * Displays password strength indicator as a form control
 * Wraps the PasswordStrengthMeter component for use in forms
 * Performance: Memoized to prevent unnecessary re-renders
 */

import React, { memo } from 'react';
import { PasswordStrengthMeter } from './PasswordStrengthMeter';
import type { ControlRendererProps } from '../types';

const PasswordStrengthMeterControl = memo<ControlRendererProps>(({ control, value }) => {
  const password = typeof value === 'string' ? value : '';
  const showFeedback = (control.config?.showFeedback as boolean) ?? true;
  const showScore = (control.config?.showScore as boolean) ?? true;

  return (
    <div className="af-control-wrapper af-password-strength-meter-control">
      {control.label && <label className="af-control__label">{control.label}</label>}

      <PasswordStrengthMeter
        password={password}
        showFeedback={showFeedback}
        showScore={showScore}
        ariaLabel={control.label || 'Password strength'}
      />

      {control.helpText && <div className="af-control__help">{control.helpText}</div>}
    </div>
  );
});

PasswordStrengthMeterControl.displayName = 'PasswordStrengthMeterControl';

export default PasswordStrengthMeterControl;
